import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import { Link, useLocation, useParams } from "react-router-dom";
// @ts-expect-error - TS7016 - Could not find a declaration file for module 'query-string'. '/Users/dkrajnak/workspace/aviso/sse-frontend/react/node_modules/query-string/index.js' implicitly has an 'any' type.
import queryString from "query-string";
import SecondaryNavLayout from "../../../../Layout/SecondaryNavLayout";
import SecondaryNavButton from "../../../../UI/SecondaryNav/SecondaryNavButton";
import DuplicatesDetailsTabs from "./RuleSetDetailTabs";
import DuplicateAutoMergeModal from "../../../../Presentational/DuplicatePerson/DuplicateAutoMergeModal";
import { getRuleSetEditPath } from "../AdminDuplicateDetectionRoutes";
import DuplicatePersonService from "../../../../../Services/DuplicatePerson.service";
import useService from "../../../../Hooks/useService";
import DuplicateRefreshModal from "../../../../Presentational/DuplicatePerson/DuplicateRefreshModal";
import ContentLayout from "../../../../Layout/ContentLayout";
import { AlertInfo } from "../../../../UI/StandardAlerts/StandardAlerts";
import PersonMergeService from "../../../../../Services/PersonMerge.service";
const RuleSetDetail = () => {
    var _a;
    const [automergeModalIsOpen, setAutomergeModalOpen] = React.useState(false);
    const [refreshModalIsOpen, setRefreshModalIsOpen] = React.useState(false);
    const params = useParams();
    // @ts-expect-error - TS2339 - Property 'id' does not exist on type '{}'.
    const ruleSetId = parseInt(params.id, 10);
    const { search } = useLocation();
    const { customRulesTab } = queryString.parse(search);
    const [isViewRefreshingState, loadIsViewRefreshing] = useService(DuplicatePersonService.isDetectedDuplicateViewRefreshing);
    const [isAutoMerging, loadIsAutomerging] = useService(PersonMergeService.isAutoMerging);
    React.useEffect(() => {
        loadIsViewRefreshing();
        loadIsAutomerging();
    }, [loadIsAutomerging, loadIsViewRefreshing]);
    const navButton = [
        _jsx(Link, { to: getRuleSetEditPath(ruleSetId), children: _jsx(SecondaryNavButton, { icon: "pencil", label: "Edit", title: "Edit RuleSet" }) }, "edit"),
        _jsx(SecondaryNavButton, { icon: "print-search", label: "Detect New Duplicates", title: "Detect New Duplicates", disabled: isViewRefreshingState.data === true, onClick: () => setRefreshModalIsOpen(true) }),
        _jsx(_Fragment, { children: customRulesTab === "Simple" && (_jsx(SecondaryNavButton, { icon: "magic", className: "btn btn-link", title: isAutoMerging.data
                    ? "Automerge process is already happening in the background."
                    : undefined, onClick: () => setAutomergeModalOpen(true), label: "Auto Merge", disabled: (_a = isAutoMerging.data) !== null && _a !== void 0 ? _a : false }, "automerge")) }),
    ];
    const [refreshTable, setRefreshTable] = React.useState(false);
    const triggerRefreshTable = () => {
        setRefreshTable(true);
    };
    return (_jsxs(SecondaryNavLayout, { dontAddSpacer: true, nav: _jsx("div", { className: "d-flex", children: navButton }), children: [_jsxs(ContentLayout, { paddingBottom: true, paddingTop: true, children: [isAutoMerging.data && (_jsx(AlertInfo, { message: "People are currently being auto-merged in the background." })), _jsx("div", { className: "title-block clearfix", children: _jsx(DuplicatesDetailsTabs, { currentTab: customRulesTab, id: ruleSetId, isDuplicateViewRefreshing: isViewRefreshingState.data === true, refreshTable: refreshTable, setRefreshTable: setRefreshTable }) })] }), _jsx(DuplicateAutoMergeModal, { isOpen: automergeModalIsOpen, onModalClosed: () => {
                    setAutomergeModalOpen(false);
                    triggerRefreshTable();
                    loadIsAutomerging();
                }, ruleSetId: ruleSetId }), _jsx(DuplicateRefreshModal, { isOpen: refreshModalIsOpen, onModalClosed: () => {
                    setRefreshModalIsOpen(false);
                    loadIsViewRefreshing();
                } })] }));
};
export default RuleSetDetail;
